import React from 'react';

import ConversationStarters from './conversation_starters';
import MessageList from './message_list';
import LoadingSpinner from 'components/ui/loading_spinner';

import type { Message } from './types';

interface Props {
  messages: Message[];
  resuming: boolean;
  showAdminDetails: boolean;
  speaking: boolean;
  onSelectStarter: (prompt: string) => void;
  onStopSpeaking: () => void;
}

export default function ConversationBody({
  messages,
  resuming,
  showAdminDetails,
  speaking,
  onSelectStarter,
  onStopSpeaking,
}: Props) {
  if (resuming && messages.length === 0) {
    return <LoadingSpinner />;
  }

  return (
    <>
      <ConversationStarters onSelect={onSelectStarter} />
      <MessageList
        messages={messages}
        showAdminDetails={showAdminDetails}
        speaking={speaking}
        onStopSpeaking={onStopSpeaking}
      />
    </>
  );
}
